import { Stack } from '@mantine/core';

export const ShowDetails: React.FC<{ id?: number | string }> = ({ id }) => {
  return <Stack sx={(theme) => ({ maxWidth: theme.breakpoints.xs })}></Stack>;
};
